<template>
  <div class="wrap">
    <div class="header">
      <img
        src="https://p0.ssl.qhimg.com/t110b9a9301c5f7a5bc58bbb4ee.png"
        alt=""
        class="headerLogo"
      />
      <img
        @click="showPopup"
        src="https://p3.ssl.qhimg.com/t110b9a93012f34251d9da24395.png"
        alt=""
        class="headerMore"
      />
    </div>
  </div>
  <van-popup v-model:show="show" position="bottom">
    <div
      @click="handleClick(item.href, item.path, item.key)"
      v-for="(item, index) in menu"
      :key="item.key"
      class="headerLi"
    >
      <a href="javascript:void(0);">{{ item.title }}</a>
    </div>
  </van-popup>
</template>

<script setup>
import { ref } from 'vue'
const show = ref(false)
const selectedKey = ref('home')

const menu = [
  {
    key: 'home',
    title: '首页',
    href: '#home'
  },
  {
    key: 'agenda',
    title: '日程',
    path: '/new/2024/agenda.html'
  },
  {
    key: 'guest',
    title: '嘉宾',
    path: '/new/2024/guest.html'
  },
  {
    key: 'activity',
    title: '活动',
    href: '#activity'
  },
  {
    key: 'news',
    title: '新闻中心',
    href: '#news'
  },
  {
    key: 'ticket',
    title: '购票链接',
    path: 'https://isc.360.com/2024/ticket'
  },
  {
    key: 'previous',
    title: '往届回顾',
    path: 'https://isc.360.com/new/events/history.html'
  }
]
const showPopup = () => {
  show.value = true
}

const handleClick = (href, path, key) => {
  show.value = false
  if (href) {
    scrollToSection(href)
  } else if (key === 'agenda') {
    const baseUrl = window.location.origin
    window.open(`${baseUrl}${path}`, '_blank')
    return
  } else if (path) {
    window.open(path, '_blank')
  }
}

const scrollToSection = (href) => {
  const element = document.querySelector(href)
  if (element) {
    window.scrollTo({
      top: element.offsetTop,
      behavior: 'smooth'
    })
  }
}
</script>

<style lang="scss" scoped>
.active {
  a {
    color: #497ced !important;
  }
}
.wrap {
  position: fixed;
  z-index: 200;
  // width: 343px;
  width: 90%;
  border-radius: 121px;
  opacity: 1;
  background: rgba(255, 255, 255, 0.9);
  box-sizing: border-box;
  /* Gray 中性/gray-4-分割线 */
  border: 1px solid #e8eaed;
  backdrop-filter: blur(20px);
  margin: 20px 24px 0;
  height: 42px;
}
.header {
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  &Logo {
    width: 97px;
    height: 28px;
  }
  &More {
    width: 20px;
  }
}
.van-popup {
  padding-top: 24px;
  border-radius: 32px 32px 0 0;
  .headerLi {
    text-align: center;
    margin-bottom: 24px;
    a {
      color: #525966;
    }
  }
}
</style>
